module.exports = '{"columns":[{"name":"s","type":"string"},{"name":"n","type":"number"},{"name":"b","type":"boolean"},{"name":"d","type":"date"},{"name":"dt","type":"datetime"},{"name":"ts","type":"timestamp"}]}\n' +
    '["hello",2,true,"2015-09-17","2015-09-17 17:18:19","2015-09-17 17:18:19.345"]\n' +
    '["hello",3,true,"2015-09-18","2015-09-17 17:18:19","2015-09-17 17:18:19.345"]\n' +
    '["hello",4,true,"2015-09-17","2015-09-17 17:18:19","2015-09-17 17:18:19.345"]\n' +
    '["hello",5,false,"2015-09-17","2015-09-17 17:18:19","2015-09-17 17:18:19.345"]\n' +
    '["",null,true,"2015-09-11","2015-09-17 17:18:19",null]\n' +
    '["hello",25,false,"2015-09-17","2015-09-17 17:18:19","2015-09-17 17:18:19.345"]\n' +
    '["ello",2,true,"2015-09-13",null,"2015-09-17 17:18:19.345"]\n';



/*****************
 ** WEBPACK FOOTER
 ** ./test/all_types_wdf.js
 ** module id = 29
 ** module chunks = 0
 **/